<template>
    <v-tabs>
        <v-tab>Обзор</v-tab>
        <v-tab-item><report-page></report-page></v-tab-item>
        <v-tab-item>Статистика2</v-tab-item>
        <v-tab-item>Статистика3</v-tab-item>
    </v-tabs>
</template>

<script>
import ReportPage from '../../components/bot/stats/Report'
export default {
    name: 'Stats',
    components: {
        ReportPage
    }
}
</script>

<style scoped>

</style>
